import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import { Empty } from "antd"

interface EmptyStateProps {
  /** Icon to display */
  icon?: IconDefinition
  /** Primary message */
  message: string
  /** Secondary message */
  subtitle?: string
  /** Additional CSS classes */
  className?: string
}

/**
 * Reusable empty state component for displaying when lists are empty
 */
const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  message,
  subtitle,
  className = "",
}) => {
  return (
    <div className={`h-full flex items-center justify-center ${className}`}>
      <div className="text-center text-gray-500">
        {icon && (
          <FontAwesomeIcon
            icon={icon}
            className="text-3xl text-gray-300 mb-3"
          />
        )}
        {icon ? (
          <p className="text-sm">{message}</p>
        ) : (
          <Empty className="mx-auto my-auto" description={message} />
        )}

        {subtitle && <p className="text-sm">{subtitle}</p>}
      </div>
    </div>
  )
}

export default EmptyState
